import {OptionsWizardOrderLeg} from "../../../../../types/OptionsTicket";
import {sum} from "../../../../../../../../js/util/UtilFunctions";
import {Optional} from "../../../../../../../../js/util/Optional";

export class TmcLegModel {

    private constructor(public readonly legs: ReadonlyArray<LegAndPrice>) {

    }

    public findLeg(code: string): Optional<LegAndPrice> {
        const leg = this.legs.find((l) => l.leg.code === code);
        return Optional.of(leg);
    }

    public get total(): number {
        return this.legs
                   .map((l) => l.price * l.leg.ratio)
                   .reduce(sum, 0);
    }

    public static of(legs: ReadonlyArray<LegAndPrice>) {
        return new TmcLegModel(legs);
    }

    public static empty() {
        return new TmcLegModel([]);
    }
}

export interface LegAndPrice {
    readonly leg: OptionsWizardOrderLeg;
    readonly price: number;
}
